import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CollectionFormSheet.styled';
import { CollectionForm } from '@/features/BookmarkCollections/components/CollectionForm/CollectionForm';

interface CollectionFormSheetProps {
  isOpen: boolean;
  onClose: () => void;
  mode?: 'create' | 'edit';
  onSuccess: () => void;
  hasDescription?: boolean;
}

export const CollectionFormSheet = ({
  mode = 'create',
  hasDescription = true,
  isOpen,
  onClose,
  onSuccess,
}: CollectionFormSheetProps) => {
  const { t } = useTranslation();

  return (
    <S.CollectionFormBottomSheet
      isOpen={isOpen}
      close={onClose}
      title={
        mode === 'create'
          ? t('bookmark_collections.form_title')
          : t('bookmark_collections.edit_collection_dropdown')
      }
    >
      <CollectionForm
        mode={mode}
        onSuccess={onSuccess}
        hasDescription={hasDescription}
      />
    </S.CollectionFormBottomSheet>
  );
};
